import { Plus, Tags, Ruler as RulerIcon } from "lucide-react";
import { Link } from "react-router-dom";

/**
 * EmptyDictPrompt — empty-state shown inside AddTableWizard when the tenant
 * hasn't defined any beden serisi (kind=series) or ölçü grubu (kind=group)
 * yet. Deep-links to the corresponding dictionary page so the merchant can
 * create the missing entry and come back.
 */
export const EmptyDictPrompt = ({ kind }) => {
    const isSeries = kind === "series";
    const Icon = isSeries ? Tags : RulerIcon;
    return (
        <div className="rounded-2xl border border-border bg-surface overflow-hidden" data-testid={`empty-${kind}-prompt`}>
            <div className="px-8 py-12 text-center max-w-2xl mx-auto">
                <div className="inline-flex h-14 w-14 rounded-2xl border border-border bg-muted/40 items-center justify-center mb-5">
                    <Icon className="h-6 w-6" strokeWidth={1.5} />
                </div>
                <h2 className="font-display text-2xl font-bold tracking-tight">
                    {isSeries ? "Henüz beden serisi yok" : "Henüz ölçü grubu yok"}
                </h2>
                <p className="text-sm text-muted-foreground mt-2 leading-relaxed">
                    Tablo oluşturmak için önce sözlüğünde{" "}
                    {isSeries
                        ? <>en az bir <strong className="text-foreground">beden serisi</strong> (örneğin &ldquo;Alfa XS–XXL&rdquo; veya &ldquo;Avrupa 32–46&rdquo;) tanımlı olmalı.</>
                        : <>en az bir <strong className="text-foreground">ölçü grubu</strong> (örneğin &ldquo;Üst Giyim: Göğüs, Bel, Omuz&rdquo;) tanımlı olmalı.</>
                    }
                </p>
                <Link
                    to={isSeries ? "/app/sizing/sizes" : "/app/sizing/measurement-groups"}
                    className="mt-6 inline-flex items-center gap-1.5 rounded-md bg-foreground text-background px-4 h-10 text-xs font-medium hover:bg-foreground/90 transition-colors"
                    data-testid={`go-create-${kind}`}
                >
                    <Plus className="h-3.5 w-3.5" /> {isSeries ? "Beden serisi oluştur" : "Ölçü grubu oluştur"}
                </Link>
            </div>
        </div>
    );
};
